import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EMPLOYEE_NAME_LENGTH } from '../../constants/requisitesLength';
import { checkMatch, checkMaxLength, checkNotEmpty } from '../../helpers/validators';
import { MatchLink } from '../MatchLink';
export const checkName = ({ value, required, type = 'lostfocus' }) => {
    if (required) {
        return checkNotEmpty({ value, type }) || checkMaxLength({ value, length: EMPLOYEE_NAME_LENGTH, type });
    }
    return value ? checkMaxLength({ value, length: EMPLOYEE_NAME_LENGTH, type }) : null;
};
const getWarningMessage = (cause, link) => (_jsxs(_Fragment, { children: [`Сотрудник с такими ФИО и ${cause} уже`, link ? _jsx("br", {}) : ' ', "\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442", link && '. ', link && _jsx(MatchLink, { matchEmployeeLink: link })] }));
export const checkMatchNameBday = ({ value, matchValue, matchEmployeeLink, level, }) => {
    return checkMatch({
        value,
        matchValue,
        matchFields: ['firstName', 'lastName', 'middleName', 'birthday'],
        message: getWarningMessage('датой рождения', matchEmployeeLink),
        level,
    });
};
export const checkMatchNameEmail = ({ value, matchValue, matchEmployeeLink, level, }) => {
    return checkMatch({
        value,
        matchValue,
        matchFields: ['firstName', 'lastName', 'middleName', 'email'],
        message: getWarningMessage('электронной почтой', matchEmployeeLink),
        level,
    });
};
export const checkMatchNamePhone = ({ value, matchValue, matchEmployeeLink, level, }) => {
    return checkMatch({
        value,
        matchValue,
        matchFields: ['firstName', 'lastName', 'middleName', 'phone'],
        message: getWarningMessage('телефоном', matchEmployeeLink),
        level,
    });
};
